/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Source_Explicit_TeamInputs */



/**
* | output |
* | --- |
* | "Explicit team override" |
*
* @param {Rights_Source_Explicit_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_source_explicit_team = /** @type {((inputs?: Rights_Source_Explicit_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Source_Explicit_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Explizite Team-Ausnahme")
	return /** @type {LocalizedString} */ ("Explicit team override")
});